import React, { useState, useEffect } from 'react';
import { handleAppDownload, openDemoBookingModal } from '../../utils/functions';
import apiService from '../../services/api';
import LiveOffersModule from './modules/LiveOffersModule';
import IRMModule from './modules/IRMModule';
import FreightCalculatorModule from './modules/FreightCalculatorModule';
import NBFCCalculatorModule from './modules/NBFCCalculatorModule';

const HeroModules = () => {
  return (
    <section className="hero-modules-section">
      <div className="container">
        <div className="modules-grid">
          <LiveOffersModule />
          <IRMModule />
          <FreightCalculatorModule />
          <NBFCCalculatorModule />
        </div>
      </div>
    </section>
  );
};

export default HeroModules;

